import { IObjectTranslatable, HtmlColorCodeTranslator } from ".";
import { ITypeDefinable, BeanTypes, IPolylineItemBean } from "../beans/items";
import { IItem, PolylineItem } from "../../../../domain/document/items";
import { Rectangle, Point, Size, LineStyle, Color } from "../../../../domain/drawing";

export class PolylineItemTranslator implements IObjectTranslatable {
  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as IPolylineItemBean;
    const result = new PolylineItem();
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.isEditable = true; // TODO:特に問題なければプロパティを削除する
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = !!bean.isVisible;
    result.typeDetail = bean.typeDetail;
    result.viewTitle = bean.viewTitle;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.geometry.rectangle = new Rectangle(new Point(bean.x, bean.y), new Size(bean.width, bean.height));
    result.lineStyle = new LineStyle(new Color(bean.color), bean.state, bean.thickness, bean.opacity);
    result.points = this.toPoints(bean.xPositionsText, bean.yPositionsText);
    return result;
  }

  private toPoints(xPositionsText: string, yPositionsText: string): Point[] {
    if (!xPositionsText || !yPositionsText) { return []; }
    const xPositions = xPositionsText.split(",");
    const yPositions = yPositionsText.split(",");
    const points: Point[] = [];
    for (let index = 0; index < xPositions.length; ++index) {
      const point = new Point(Number(xPositions[index]), Number(yPositions[index]));
      points.push(point);
    }
    return points;
  }

  toBean(item: IItem): ITypeDefinable {
    const target = item as PolylineItem;
    const bean: IPolylineItemBean = {
      type: BeanTypes.FreeLine,
      uniqueKey: target.uniqueKey,
      id: target.id,
      sectionObjectUid: target.sectionObjectUid,
      isVisible: target.isVisible,
      printVisible: target.printBehavior.shouldPrint,
      previewVisible: target.printBehavior.shouldPreview,
      x: Math.floor(target.geometry.rectangle.x),
      y: Math.floor(target.geometry.rectangle.y),
      width: Math.floor(target.geometry.rectangle.width),
      height: Math.floor(target.geometry.rectangle.height),
      color: HtmlColorCodeTranslator.fromColor(target.lineStyle.color),
      state: target.lineStyle.kind,
      thickness: target.lineStyle.width,
      opacity: target.lineStyle.opacity,
      isAdditional: target.isAdditional,
      isDeleted: target.isDeleted,
      xPositionsText: this.toXPositionsText(target.points),
      yPositionsText: this.toYPositionsText(target.points),
      typeDetail: target.typeDetail,
      viewTitle: target.viewTitle,
    };
    return bean;
  }

  private toXPositionsText(points: Point[]): string {
    // 現状では整数しか格納されていなかったが、念のためroundしている
    return points.map(p => Math.round(p.x)).join(",");
  }

  private toYPositionsText(points: Point[]): string {
    // 現状では整数しか格納されていなかったが、念のためroundしている
    return points.map(p => Math.round(p.y)).join(",");
  }
}
